import { styled, globalStyles } from "../../stitches.config";

const CopyrightWrapper = styled("div", {
  fontFamily: "Roboto",
  fontWeight: 300,
  fontSize: "12px",
  margin: "auto",
  textAlign: "center",
  marginBottom: "50px",
});

export { CopyrightWrapper };
